import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import CBT from './components/CBT';
import CBTLanding from './components/CBTLanding';
import ExamSearchSelection from './components/ExamSearchSelection';
import DiagnosticTest from './components/diagnostic/DiagnosticTest';
import DiagnosticResults from './components/diagnostic/DiagnosticResults';
import PersonalDashboard from './components/PersonalDashboard';
import WrongAnswerNote from './components/WrongAnswerNote';
import LearningProgressTracker from './components/LearningProgressTracker';
import ErrorBoundary from './components/ErrorBoundary';
import FloatingFeedback from './components/feedback/FloatingFeedback';
import ExamDetailPage from './components/ExamDetailPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import AboutPage from './components/AboutPage';
import TermsOfService from './components/TermsOfService';
import ContactPage from './components/ContactPage';
import KoreanNameMappingDemo from './components/demo/KoreanNameMappingDemo';
import IntegrationTest from './components/demo/IntegrationTest';
// Mock exam components temporarily disabled
// import MockExam from './components/MockExam';
// import MockExamPage from './components/MockExamPage';
// import ProtectedMockExam from './components/ProtectedMockExam';
import { AuthProvider } from './contexts/AuthContext';
import { QNetDataProvider } from './contexts/QNetDataContext';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <QNetDataProvider>
          <ErrorBoundary>
          <Router>
          <div className="App">
            <Routes>
              {/* 메인 페이지 */}
              <Route path="/" element={<CBTLanding />} />
              
              {/* 시험 검색 페이지 */}
              <Route path="/exams" element={<ExamSearchSelection />} />

              {/* 정책·소개 페이지 (애드센스 승인용) - catch-all(/:examSlug)보다 우선 매칭됨 */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* 자격증별 상세 페이지 (618개 모든 자격증 지원) */}
              <Route path="/:examSlug" element={<ExamDetailPage />} />
              
              
              {/* 모의고사 기능 임시 비활성화 - AI 품질 개선 후 재활성화 예정 */}
              {/* <Route path="/mock-exams" element={<MockExamPage />} /> */}
              {/* <Route path="/mock-exam/:examType" element={<ProtectedMockExam />} /> */}
              
              {/* CBT 시험 페이지 */}
              <Route path="/:examSlug/:year/:session" element={<CBT />} />
              
              {/* 개인 대시보드 */}
              <Route path="/dashboard" element={<PersonalDashboard />} />
              
              {/* 오답노트 */}
              <Route path="/wrong-answers" element={<WrongAnswerNote />} />
              
              {/* 학습 진도 */}
              <Route path="/progress" element={<LearningProgressTracker />} />
              
              {/* 진단평가 */}
              <Route path="/diagnostic/:examSlug" element={<DiagnosticTest />} />
              <Route path="/diagnostic/:examSlug/results" element={<DiagnosticResults />} />
              
              {/* 데모 페이지 */}
              <Route path="/demo/korean-mapping" element={<KoreanNameMappingDemo />} />
              <Route path="/demo/integration-test" element={<IntegrationTest />} />
            </Routes>
            
            {/* 베타 피드백 버튼 - 모든 페이지에서 표시 */}
            <FloatingFeedback />
          </div>
          </Router>
          </ErrorBoundary>
        </QNetDataProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;